import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
var styles = {
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      padding: ", ";\n    "])), t.mobilePopupHeaderPadding);
  }
};
export var jsStyles = memoizeStyle(styles);